import css from './ImageCarousel.less'
import type {SetStateAction} from 'react';
import React, { useState} from 'react'
import cn from 'classnames'
import assert from 'assert'
import missingImage from '../../images/missing-vehicle-photo.jpg'
import {wrapIdx} from '../kb'
import Icon from './Icon'
import icons from '../../markons/markons'

export type CarouselImage = {
    id: number
    url: string
    width: number
    height: number
    size?: number
}

interface ImageCarouselProps {
    images: CarouselImage[]
}

export function ImageCarousel({images}: ImageCarouselProps) {
    const [currIdx, setCurrIdx] = useState(0)
    const [prevImg, setPrevImg] = useState<CarouselImage|null>(null)

    const currImg = images?.length ? images[currIdx] : null

    const changeImage = (idx: SetStateAction<number>) => {
        setPrevImg(currImg)
        setCurrIdx(idx)
    }

    const changeImageRelative = (count: number) => {
        changeImage(idx => wrapIdx(idx + count, images.length))
    }

    if(!images?.length) {
        return (
            <div className={css.imageWrap}>
                <img className={css.image} src={missingImage}/>
            </div>
        )
    }

    assert(currImg)
    assert(images?.length)

    return (
        <div className={css.imageWrap}>
            {prevImg ?
                <img alt="Previous vehicle photo" key={prevImg.id} className={cn(css.image, css.previousImage)}
                     src={prevImg.url}/>
                : null
            }
            <img alt="Photo of vehicle" key={currImg.id} className={cn(css.image, css.currentImage)}
                 src={currImg.url}/>

            {images.length > 1 ? <>
                <div className={css.leftOverlay} onClick={() => changeImageRelative(-1)}>
                    <Icon className={css.arrowIcon} name={icons.ionArrowLeftB}/>
                </div>
                <div className={css.rightOverlay} onClick={() => changeImageRelative(1)}>
                    <Icon className={css.arrowIcon} name={icons.ionArrowRightB}/>
                </div>
                <div className={css.imageCount}>{currIdx+1} of {images.length}</div>
            </> : null}
        </div>
    )
}
